import { createListenerMiddleware } from '@reduxjs/toolkit';

import i18n, { updateDirection } from '@/i18n';
import { applyDateLocale } from '@/shared/lib/date';
import { RootState } from '@/app/types';

import { setLanguage, setLayoutType } from './slice';

export const languageListenerMiddleware = createListenerMiddleware();

languageListenerMiddleware.startListening({
  actionCreator: setLanguage,
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const currentLang = state.language.currentLanguage;

    if (currentLang === action.payload) {
      await i18n.changeLanguage(currentLang);
      updateDirection(currentLang);
      applyDateLocale(currentLang);
    }
  }
});

languageListenerMiddleware.startListening({
  actionCreator: setLayoutType,
  effect: async (_, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const currentLang = state.language.currentLanguage;

    await i18n.changeLanguage(currentLang);
    updateDirection(currentLang);
    applyDateLocale(currentLang);
  }
});
